import { Component } from '@angular/core';

@Component({
    selector: 'pos-app-empty-route',
    template: ''
})
export class EmptyRouteComponent {
}

